<template>
    <div class="tab-content-container">
        <WebSocket :url="webSocketUrl" @receive-message="receiveMessage"></WebSocket>
        <Row type="flex" justify="center" align="top" class="menu-actions">
            <Col flex="auto">
            <div ref="uirEcharts" :style="{ width: chartWidth, height: '550px' }"></div>
            </Col>
            <Col flex="200px" class="desc-row">
            <Row type="flex" class="normal-row">
                <Col flex="1">
                <Button type="success" size="small" v-if="curveState == 'end'" @click.native="recordAction('start')"
                    icon="md-play">{{ getTranslation('k393') }}</Button>
                <Button type="warning" size="small" v-if="curveState == 'start'" @click.native="recordAction('end')"
                    icon="md-square">{{ getTranslation('k394') }}</Button>
                </Col>
            </Row>

            <Row type="flex" class="normal-row">
                <Col flex="1">{{ getTranslation('b006') }}&nbsp;<Input type="number" @on-change="changePid()"
                    v-model="pid" style="width: 80px"></Input></Col>
            </Row>
            <Row type="flex" class="normal-row">
                <Col flex="1">{{ getTranslation('k099') }}&nbsp;<Input type="number" v-model="size"
                    style="width: 80px"></Input></Col>
            </Row>
            <Row type="flex" class="normal-row">
                <Col flex="1">{{ getTranslation('k396') }}&nbsp;<Input type="number" style="width: 80px" 
                    v-model="selectLine" @on-change="changeSelectLine" ></Input></Col>
            </Row>
            <Row type="flex" class="normal-row">
                <Col flex="1">{{ getTranslation('k101') }}&nbsp;<span>{{ weldAt }}</span></Col>
            </Row>
            <Row type="flex" class="normal-row">
                <Col flex="1">{{ getTranslation('k102') }}&nbsp;<span>{{ weldCount }}</span></Col>
            </Row>
            <Row type="flex" class="normal-row">
                <Col flex="1">{{ getTranslation('c010') }}{{ totalLine }}{{ getTranslation('s309') }}</Col>
            </Row>

            <Row type="flex" class="normal-row">
                <Col flex="1"><Button type="info" size="small" @click.native="delCurve()" icon="md-refresh">{{
                    getTranslation('k103')
                    }}</Button></Col>
            </Row>
            <Row type="flex" class="normal-row">
                <Col flex="1"><Button type="primary" size="small" @click.native="createCurve()" icon="md-download" :disabled="curveState == 'start'">{{
                    getTranslation('k397')
                    }}</Button></Col>
            </Row>
            <Row type="flex" class="normal-row ">
                <Col flex="1"><Button type="warning" size="small" :disabled="disableDownload"
                    @click.native="downloadTo('mac')" icon="md-settings">{{ getTranslation('k398')
                    }}</Button></Col>
            </Row>          

            </Col>
        </Row>
    </div>
</template>
<script>
import { Row, Col, Input, Button } from "view-design"
import { API_URL } from '@/constants/const';
import axios from 'axios';
import { mapGetters } from 'vuex'
import { fixed2 } from '@/util/numberFormat.js'
import { postJsError } from '@/util/util.js'
import WebSocket from '@/components/WebSocket.vue';
export default {
    name: 'UirLine', // 组件名称
    components: {
        Row, Col, Input, Button, WebSocket
    },
    props: {
    },
    data() {
        return {
            data: {},
            pid: 0,
            mac: 0,
            size: 100,
            chartWidth: '100%',
            myChart: null,
            curveState: 'end',
            disableDownload: true,
            totalLine: 0,
            allRecordData: [],
            selectLine: 1,
            weldAt: '',
            weldCount: '',
            recordOption: null,
            zoomStart: 0,
            zoomEnd: 100,
            startPos:null,
            createRecord:[],
        }
    },
    computed: {
        ...mapGetters(['getTranslation']),
        timeList() {
            return [
                {
                    "value": 30,
                    "text": this.getTranslation('s306')
                },
                {
                    "value": 60,
                    "text": this.getTranslation('s307')
                },
                {
                    "value": 90,
                    "text": this.getTranslation('s308')
                }
            ]
        },
        webSocketUrl() {
            return API_URL['webSocket'] + "?mac=" + this.$route.query.mac;
        },

    },
    watch: {

    },
    created() {
        this.init();
    },
    methods: {
        init() {
            this.mac = this.$route.query.mac;
            this.pid = localStorage.getItem('system.uir.prgid') || 0;
            this.size = localStorage.getItem('system.uir.size') || 100;
            this.initEcharts();
            this.getData(false);
        },
        initEcharts() {
            this.$nextTick(() => {
                const parentWidth = this.$refs.uirEcharts.offsetWidth;
                this.chartWidth = `${parentWidth}px`;
                this.myChart = this.$echarts.init(this.$refs.uirEcharts);
                this.recordOption = {
                    title: {
                        text: "weld-curve",
                        show: false
                    },
                    toolbox: {
                        feature: {
                            saveAsImage: {}
                        }
                    },
                    tooltip: {
                        trigger: 'axis',
                        formatter: (params) => this.formatCurveTooltip(params)
                    },
                    grid: {
                        left: '45px',
                        right: '45px',
                        top: '40px'
                    },
                    yAxis: {
                        axisLine: {
                            onZero: true
                        },
                        type: 'value'
                    },
                    dataZoom: [{
                        id: 'dataZoomX',
                        type: 'slider',
                        xAxisIndex: 0,
                        bottom: 30,
                        filterMode: 'empty',
                        showDataShadow: true,
                        start: this.zoomStart,
                        end: this.zoomEnd
                    },
                    {
                        type: 'slider',
                        xAxisIndex: 0,
                        filterMode: 'empty',
                        showDataShadow: true
                    },
                    {
                        type: 'slider',
                        yAxisIndex: 0,
                        filterMode: 'empty',
                        showDataShadow: true
                    },
                    {
                        type: 'inside',
                        xAxisIndex: 0,
                        filterMode: 'empty'
                    },
                    {
                        type: 'inside',
                        yAxisIndex: 0,
                        filterMode: 'empty'
                    }
                    ],
                    xAxis: {
                        data: []
                    },
                    legend: {
                        data: []
                    },
                    series: [{
                        name: 'lineMin',
                        type: 'line',
                        data: []
                    }, {
                        name: 'lineMax',
                        type: 'line',
                        data: []
                    }],
                    graphic: [
                        {
                            id: 'selectionRect',
                            type: 'rect',
                            invisible: true,
                            silent: true,
                            shape: {
                                x: 0,
                                y: 0,
                                width: 0,
                                height: 0
                            },
                            style: {
                                fill: 'rgba(135, 206, 250, 0.3)',
                                stroke: '#1E90FF',
                                lineWidth: 1
                            },
                            z: 100
                        }
                    ]
                };
                this.myChart.setOption(this.recordOption, true);
                this.setBrush();
            })
        },
        getData(showErrmsg = true) {
            let url = API_URL["systemUirHistory"];
            let params = {
                mac: this.mac,
                pid: this.pid,
                size: this.size,
            }
            axios.get(url, {
                params: params
            })
                .then(res => {
                    if (res && res.data && res.data.code == 200) {
                        localStorage.setItem('system.uir.prgid', this.pid);
                        localStorage.setItem('system.uir.size', this.size);
                        if (!res.data.data.batch.finish) {
                            this.curveState = 'start';
                        } else {
                            this.curveState = 'end';
                        }
                        let items = res.data.data.curves || [];
                        this.allRecordData = []
                        this.refreshChartLotRecord(items);

                        //this.$Message.success(res.data.msg);
                    } else if (res && res.data && res.data.msg && res.data.code != 26299 && showErrmsg) {
                        this.$Message.error(res.data.msg);
                    }
                })
                .catch((err) => {
                    postJsError(err)
                    this.$Message.error(this.getTranslation('c001'));
                })
        },
        changePid() {
            this.getData();
        },
        changeSelectLine() {
            if (isNaN(parseInt(this.selectLine))) {
                return
            }
            if( this.selectLine < 0){
                this.$nextTick(() => {
                    this.selectLine = 0
                })
                return 
            }

            if (this.selectLine > this.allRecordData.length) {
                this.$nextTick(() => {
                    this.selectLine = this.allRecordData.length
                    this.totalLine = this.selectLine
                })
                return
            }
            for (let i = 0; i < this.allRecordData.length; i++) {
                if (i == (this.selectLine - 1)) {
                    this.allRecordData[i].color = '#f00';
                    this.allRecordData[i].zlevel = 100; // 调整显示的层级
                    this.weldAt = this.allRecordData[i].weldAt
                    this.weldCount = this.allRecordData[i].weldCNT
                } else {
                    this.allRecordData[i].color = '#0f0';
                    this.allRecordData[i].zlevel = 1;
                }
            }
            this.$Message.success(this.getTranslation('s311'))
            this.recordOption.series = this.allRecordData;
            this.myChart.setOption(this.recordOption);
            

        },
        async recordAction(action) {
            let url = API_URL["systemUirStart"];           
            if (action == 'end') {
                url = API_URL["systemUirEnd"];
            }
            let params = {
                mac: this.mac,
            }
            
            axios.get(url, {
                params: params
            })
                .then(res => {
                    if (res && res.data && res.data.code == 200) {
                        if (this.curveState == 'start') {
                            this.curveState = 'end';
                        } else {
                            this.allRecordData = [];
                            this.refreshChartLotRecord([]);
                            this.curveState = 'start';
                        }
                        this.$Message.success(res.data.msg);
                    } else if (res && res.data && res.data.code == 202) {
                        //特殊场景，状态不一致
                        if (this.curveState == 'start') {                            
                            this.curveState = 'end';
                        } else {
                            this.allRecordData = [];
                            this.refreshChartLotRecord([]);
                            this.curveState = 'start';
                        }
                        this.$Message.error(res.data.msg);
                    } else if (res && res.data && res.data.msg) {
                        this.$Message.error(res.data.msg);
                    }
                })
                .catch((err) => {
                    postJsError(err)
                    this.$Message.error(this.getTranslation('c001'));
                })
        },
        refreshChartLotRecord(items) {
            items.forEach((item) => {
                if (item && item.data) {
                    let name = 'line' + (this.allRecordData.length + 1);
                    this.allRecordData.push({
                        heronCurveId: item.id, // 自定义数据编号
                        weldAt: item.at,   // 焊接时间
                        weldCNT: item.cnt,// 总焊点数
                        name: name,
                        type: 'line',
                        tiled: '总量',
                        showSymbol: false,
                        color: '#0f0',
                        data: item.data,
                        lineStyle: {
                            width: 1
                        }
                    });
                }
            });
            this.totalLine = this.allRecordData.length
            let iMax = 0;
            for (let i = 0; i < this.allRecordData.length; i++) {
                if (this.selectLine % 1 === 0 && i == (this.selectLine - 1)) {
                    this.allRecordData[i].color = '#f00';
                    this.allRecordData[i].zlevel = 100;
                    this.weldAt = this.allRecordData[i].weldAt;
                    this.weldCount = this.allRecordData[i].weldCNT;
                } else {
                    this.allRecordData[i].color = '#0f0';
                    this.allRecordData[i].zlevel = 1;
                }
                if ((this.allRecordData[i].data || []).length > iMax) {
                    iMax = (this.allRecordData[i].data || []).length;
                }
            }
            let xAxis = [];
            for (let i = 0; i < iMax; i++) {
                xAxis.push(i);
            }
            this.recordOption.xAxis = {
                axisLine: {
                    onZero: true
                },
                type: 'category',
                boundaryGap: false,
                splitLine: {
                    show: true
                },
                data: xAxis
            };
            
            this.recordOption.series = this.allRecordData;
            this.myChart.setOption(this.recordOption, true);
            
        },
        delCurve() {
            if (isNaN(parseInt(this.selectLine))) {
                this.$Message.error(this.getTranslation('s312'));
                return
            }

            this.$Modal.confirm({
                title: "",
                content: this.getTranslation('b055'),
                okText: this.getTranslation('b181'),
                cancelText: this.getTranslation('b182'),
                onOk: () => {
                    let ix = parseInt(this.selectLine) - 1;
                    if (ix >= 0 && this.allRecordData.length > ix) {
                        let url = API_URL["systemUirDelete"];
                        let params = {
                            id: this.allRecordData[ix].heronCurveId,
                        }
                        axios.get(url, {
                            params: params
                        })
                            .then(res => {
                                if (res && res.data && res.data.code == 200) {
                                    this.$Message.success(res.data.msg);
                                    this.allRecordData.splice(ix, 1);
                                    this.allRecordData = this.resetRecordName(this.allRecordData);
                                    this.totalLine = this.allRecordData.length
                                    if (ix >= 0 && this.allRecordData.length > ix) {
                                        this.allRecordData[ix].color = '#f00';
                                        this.allRecordData[ix].zlevel = 100;
                                        this.weldAt = this.allRecordData[ix].weldAt;
                                        this.weldCount = this.allRecordData[ix].weldCNT
                                    }
                                    let iMax = 0;
                                    for (let i = 0; i < this.allRecordData.length; i++) {
                                        if ((this.allRecordData[i].data || []).length > iMax) {
                                            iMax = (this.allRecordData[i].data || []).length;
                                        }
                                    }
                                    let xAxis = [];
                                    for (let i = 0; i < iMax; i++) {
                                        xAxis.push(i);
                                    }
                                    this.recordOption.xAxis = {
                                        axisLine: {
                                            onZero: true
                                        },
                                        type: 'category',
                                        boundaryGap: false,
                                        splitLine: {
                                            show: true
                                        },
                                        data: xAxis
                                    };
                                    this.recordOption.series = this.allRecordData;
                                    this.myChart.setOption(this.recordOption, true);
                                    
                                } else if (res && res.data && res.data.msg) {
                                    this.$Message.error(res.data.msg);
                                }
                            })
                            .catch((err) => {
                                postJsError(err)
                                this.$Message.error(this.getTranslation('c001'));
                            })
                    }
                }
            });


        },
        createCurve() {
            let iLen = this.allRecordData.length;
            if (iLen < 2) {
                this.$Message.error(this.getTranslation('s317'));
                return
            }
            this.allRecordData.forEach((item) => {
                this.createRecord.push(item.heronCurveId)
            })             
            let avgData = [];
            let minData = [];
            let maxData = [];
            for (let i = 0; i < this.recordOption.xAxis.data.length; i++) {
                let sumVal = 0,
                    minVal = -1,
                    maxVal = -1;
                for (let j = 0; j < iLen; j++) {
                    let value = this.allRecordData[j].data[i];
                    if (minVal == -1 || value < minVal) {
                        minVal = value;
                    }
                    if (maxVal == -1 || value > maxVal) {
                        maxVal = value;
                    }
                    sumVal = sumVal + value;
                }
                minData.push(minVal);
                maxData.push(maxVal);
                if (iLen == 0) {
                    avgData.push(0);
                } else {
                    avgData.push(fixed2(sumVal / iLen));
                }
            }
            let aSs = [];
            aSs.push({
                name: 'Min',
                type: 'line',
                tiled: '总量',
                showSymbol: false,
                color: '#000',
                lineStyle: {
                    width: 1
                },
                data: minData
            });
            aSs.push({
                name: 'lineGen',
                type: 'line',
                tiled: '总量',
                showSymbol: false,
                color: '#f00',
                lineStyle: {
                    width: 1
                },
                data: avgData
            });
            aSs.push({
                name: 'Max',
                type: 'line',
                tiled: '总量',
                showSymbol: false,
                color: '#000',
                lineStyle: {
                    width: 1
                },
                data: maxData
            });
            this.recordOption.series = aSs;            
            this.myChart.setOption(this.recordOption, true);
            
            this.allRecordData = [];
            this.disableDownload = false;
            this.totalLine = 0
        },
        downloadTo(type) {
            let message = this.getTranslation('s318');
            let url = API_URL["systemUirDownloadMachine"] + '?mac=' + this.mac;
            if (type == "pc") {
                url = API_URL["systemUirDownloadPc"] + '?mac=' + this.mac;
                message = this.getTranslation('s319');
            }
            this.$Modal.confirm({
                title: "",
                content: message,
                okText: this.getTranslation('b181'),
                cancelText: this.getTranslation('b182'),
                onOk: () => {
                    let curveData = [];                    
                    for (let i = 0; i < this.recordOption.series.length; i++) {
                        if (this.recordOption.series[i].name == 'lineGen') {
                            curveData = this.recordOption.series[i].data;
                            break
                        }
                    }
                    
                    if (curveData.length < 1) {
                        this.$Message.error(this.getTranslation('s320')); //未生成参考曲线,不能下载
                        return
                    }
                    let params = new FormData();
                    params.append('data', curveData)
                    params.append('mac', this.mac)
                    params.append('pid', this.pid)
                    params.append('recId', this.createRecord.join(','))

                    axios.post(url, params,{ timeout: 300000 })
                        .then(res => {
                            if (res && res.data && res.data.code == 200) {
                                this.$Message.success(res.data.msg);
                            } else if (res && res.data && res.data.msg) {
                                this.$Message.error(res.data.msg);
                            }
                        })
                        .catch((err) => {
                            postJsError(err)
                            this.$Message.error(this.getTranslation('c001'));
                        })
                },
            })
        },
        receiveMessage(obj) {
            if (obj && obj.kind && this.curveState == 'start') {
                switch (obj.kind) {
                    case 'curve':
                        if (obj.data && obj.data.prgId != undefined && obj.data.prgId == this.pid && this.allRecordData.length < this.size) {
                            this.refreshChartRecord(obj.data.curves.resistance, obj.data.recId, obj.data.cnt, obj.data.at);
                        }
                        break;
                    // case 'weld':
                    //     if (obj.data && obj.data.NoWeldProgram != undefined && obj.data.NoWeldProgram == this.pid) {
                    //         this.getData();
                    //     }
                    //     break;
                    default:
                        break;
                }
            }

        },
        refreshChartRecord(data, recId, cnt, at) {
            let selLine = this.selectLine;
            let name = 'line' + (this.allRecordData.length + 1);
            let iMax = 0;
            this.allRecordData.push({
                heronCurveId: recId, // 自定义数据编号
                weldAt: at,   // 焊接时间
                weldCNT: cnt,// 总焊点数
                name: name,
                type: 'line',
                tiled: '总量',
                showSymbol: false,
                color: '#0f0',
                data: data,
                lineStyle: {
                    width: 1
                }
            });
            this.totalLine = this.allRecordData.length
            for (let i = 0; i < this.allRecordData.length; i++) {
                if (selLine % 1 === 0 && i == (selLine - 1)) {
                    this.allRecordData[i].color = '#f00';
                    this.allRecordData[i].zlevel = 100;
                    this.weldAt = this.allRecordData[i].weldAt;
                    this.weldCount = this.allRecordData[i].weldCNT
                } else {
                    this.allRecordData[i].color = '#0f0';
                    this.allRecordData[i].zlevel = 1;
                }
                if ((this.allRecordData[i].data || []).length > iMax) {
                    iMax = (this.allRecordData[i].data || []).length;
                }
            }
            let xAxis = [];
            for (let i = 0; i < iMax; i++) {
                xAxis.push(i);
            }
            this.recordOption.xAxis = {
                axisLine: {
                    onZero: true
                },
                type: 'category',
                boundaryGap: false,
                splitLine: {
                    show: true
                },
                data: xAxis
            };
            this.recordOption.series = this.allRecordData;
            this.myChart.setOption(this.recordOption, true);            
            
        },
        isInDataZoomArea(x, y) {
            const gridModel = this.myChart.getModel().getComponent('grid', 0);
            if (!gridModel) return false;
            const grid = gridModel.coordinateSystem;
            const rect = grid.getRect();
            // right-side y-axis dataZoom slider area
            if (x > rect.x + rect.width) return true;
            // bottom x-axis dataZoom slider area (below grid + legend)
            if (y > rect.y + rect.height + 35) return true;
            return false;
        },
        setBrush() {
            const zr = this.myChart.getZr();

            // Remove only our own previous handlers, leaving ECharts' internal
            // dataZoom slider handlers intact
            if (this._brushMousedown) zr.off('mousedown', this._brushMousedown);
            if (this._brushMousemove) zr.off('mousemove', this._brushMousemove);
            if (this._brushMouseup) zr.off('mouseup', this._brushMouseup);
            if (this._brushDblclick) zr.off('dblclick', this._brushDblclick);

            this._brushMousedown = (e) => {
                if (e.event.which !== 1) return;
                if (this.isInDataZoomArea(e.offsetX, e.offsetY)) return;

                const inGrid = this.myChart.containPixel({ gridIndex: 0 }, [e.offsetX, e.offsetY]);
                if (!inGrid) return;

                this.isSelecting = true;
                this.startPos = { x: e.offsetX, y: e.offsetY };

                const gridModel = this.myChart.getModel().getComponent('grid', 0);
                if (gridModel) {
                const grid = gridModel.coordinateSystem;
                const rect = grid.getRect();
                this.myChart.setOption({
                    graphic: {
                    id: 'selectionRect',
                    invisible: false,
                    shape: {
                        x: this.startPos.x,
                        y: rect.y,
                        width: 0,
                        height: rect.height
                    }
                    }
                });
                }
            };

            this._brushMousemove = (e) => {
                if (this.isSelecting && this.startPos) {
                const width = e.offsetX - this.startPos.x;
                this.myChart.setOption({
                    graphic: {
                    id: 'selectionRect',
                    shape: { width }
                    }
                });
                }
            };

            this._brushMouseup = (e) => {
                if (this.isSelecting && this.startPos) {
                this.isSelecting = false;

                const endPos = { x: e.offsetX, y: e.offsetY };
                const width = Math.abs(endPos.x - this.startPos.x);

                if (width > 10) {
                    this.applyZoom(this.startPos.x, endPos.x);
                }

                this.myChart.setOption({
                    graphic: {
                    id: 'selectionRect',
                    invisible: true
                    }
                });

                this.startPos = null;
                }
            };

            this._brushDblclick = (e) => {
                if (this.isInDataZoomArea(e.offsetX, e.offsetY)) return;
                const inGrid = this.myChart.containPixel({ gridIndex: 0 }, [e.offsetX, e.offsetY]);
                if (!inGrid) return;

                this.myChart.dispatchAction({
                type: 'dataZoom',
                dataZoomIndex: [0, 1, 2],
                start: 0,
                end: 100
                });
            };

            zr.on('mousedown', this._brushMousedown);
            zr.on('mousemove', this._brushMousemove);
            zr.on('mouseup', this._brushMouseup);
            zr.on('dblclick', this._brushDblclick);
        },
        applyZoom(startPixel, endPixel) {
            const xAxis = this.myChart.getModel().getComponent('xAxis', 0);
            if (!xAxis) return;

            const axis = xAxis.axis;
            const pixelExtent = axis.getGlobalExtent();
            const minX = Math.min(startPixel, endPixel);
            const maxX = Math.max(startPixel, endPixel);

            // 确保在轴范围内
            const clampedMin = Math.max(minX, pixelExtent[0]);
            const clampedMax = Math.min(maxX, pixelExtent[1]);

            if (clampedMax <= clampedMin) return;

            // 计算百分比
            const startPercent = (clampedMin - pixelExtent[0]) / (pixelExtent[1] - pixelExtent[0]) * 100;
            const endPercent = (clampedMax - pixelExtent[0]) / (pixelExtent[1] - pixelExtent[0]) * 100;

            this.myChart.dispatchAction({
                type: 'dataZoom',
                dataZoomId: 'dataZoomX',
                start: startPercent,
                end: endPercent
            });
            this.recordOption.dataZoom[0].start = startPercent;
            this.recordOption.dataZoom[0].end = endPercent;

        },
        formatCurveTooltip(params) {
            const lines = [];
            const tooltipParams = Array.isArray(params) ? params : [params];
            if (!tooltipParams.length) {
                return '';
            }
            let showNum = 10;
            const firstPoint = tooltipParams[0];
            lines.push(firstPoint.axisValueLabel || firstPoint.name || '');
            tooltipParams.forEach((onePoint) => {
                showNum -=1;
                if (showNum < 0){
                    return 
                }else {
                     const value = onePoint && onePoint.value !== undefined && onePoint.value !== null ? onePoint.value : '-';
                    lines.push(`${onePoint.marker || ''}${onePoint.seriesName}: ${value}`);
                }
            });

            const pointIndex = Number(firstPoint.dataIndex);
            const hasAnomaly = Array.isArray(this.expulsionPoint) && this.expulsionPoint.some((oneIndex) => Number(oneIndex) === pointIndex);
            if (hasAnomaly) {
                lines.push(this.getTranslation('m214'));
            }

            return lines.join('<br/>');
        },
        resetRecordName(record){
            if (record){
                record.forEach((item, index) => {
                    item.name = 'line' + (index + 1);
                });
            }
            return record;
        }

    }
}
</script>

<style scoped>
@import url('../../../assets/style/list.css');

.desc-row {
    margin-top: 100px;
}

.normal-row {
    margin-bottom: 10px;
}
</style>